import { useContext, useState, type ReactNode } from 'react';
import {
  InvoiceSlideinActionsContext,
  InvoiceSlideinActionsSlotContext,
} from '@/components/accounts-payable/invoice-detail/invoiceSlideinActionsContext';

/**
 * The slide-in footer is outside the invoice column. The column portals its
 * primary actions into this slot so they sit on the Close bar, and so the
 * task page (which has no footer) does not show them.
 */
export function InvoiceSlideinActionsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  return (
    <InvoiceSlideinActionsContext.Provider value={slot}>
      <InvoiceSlideinActionsSlotContext.Provider value={setSlot}>
        {children}
      </InvoiceSlideinActionsSlotContext.Provider>
    </InvoiceSlideinActionsContext.Provider>
  );
}

export function InvoiceSlideinActionsSlot({
  className,
}: {
  className?: string;
}) {
  const setSlot = useContext(InvoiceSlideinActionsSlotContext);
  return <div ref={setSlot} className={className} />;
}
